export const timeSeriesChildColumnListData = [
  {
    propName: "Planned Time",
    propType: "number",
    propValue: "",
    propAbbrevation: "PT",
    propBgColor: "#B9DDFC",
    propFgColor: "none",
  },
  {
    propName: "Actual Time",
    propType: "number",
    propValue: "",
    propAbbrevation: "AT",
    propBgColor: "#92D050",
    propFgColor: "none",
  },
  {
    propName: "Reason",
    propType: "text",
    propValue: "",
    propAbbrevation: "R",
    propBgColor: "#FF7F50",
    propFgColor: "none",
  },
  {
    propName: "Impediment",
    propType: "text",
    propValue: "",
    propAbbrevation: "I",
    propBgColor: "#FFFF00",
    propFgColor: "none",
  },
  {
    propName: "Dependency",
    propType: "text",
    propValue: "",
    propAbbrevation: "D",
    propBgColor: "#FFC000",
    propFgColor: "none",
  },
  {
    propName: "TaskEnded",
    propType: "boolean",
    propValue: "",
    propAbbrevation: "TE",
    propBgColor: "#FFB6C1",
    propFgColor: "none",
  },

];

export const TotalColumnTimeSeriesListData = [
  {
    propName: "Planned Time",
    propType: "number",
    propValue: "",
    propAbbrevation: "PT",
    propBgColor: "#B9DDFC",
    propFgColor: "none",
  },
  {
    propName: "Actual Time",
    propType: "number",
    propValue: "",
    propAbbrevation: "AT",
    propBgColor: "#92D050",
    propFgColor: "none",
  },
];

export const MDVParentColumnRawStructure = [
  {
    propName: "Planned Time",
    propType: "number",
    propValue: "",
    propAbbrevation: "PT",
    propBgColor: "#B9DDFC",
    propFgColor: "none",
  },
  {
    propName: "Actual Time",
    propType: "number",
    propValue: "",
    propAbbrevation: "AT",
    propBgColor: "#92D050",
    propFgColor: "none",
  },
  {
    propName: "Impediment",
    propType: "text",
    propValue: "",
    propAbbrevation: "I",
    propBgColor: "#FFFF00",
    propFgColor: "none",
  },
  {
    propName: "Dependency",
    propType: "text",
    propValue: "",
    propAbbrevation: "D",
    propBgColor: "#FFC000",
    propFgColor: "none",
  },
];

export const HRMSTimeSeriesChildColumnListData = [
  {
    propName: "HRMS Working Hours",
    propAbbrevation: "WH",
    propType: "text",
    propValue: "",
    // "propBgColor": parseInt(actualTime) >= 8 ? '#ff1515' : '#FA0000',
    propBgColor: '#8be3af',
    propFgColor: "none"
}
];

export const ignoredKeys = new Set([
  "Backspace",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Enter",
  "NumLock",
  "CapsLock",
  "Shift",
  "Control",
  "AltGraph",
  "Alt",
  "Meta",
  "Tab",
  " ",
  "."
]);

